import axios from "axios"
export function getUserData(phoneNumber, token) {
    return axios.post(process.env.REACT_APP_API_URL+ '/getUserData', { phoneNumber: phoneNumber }, {
        headers: {
            'Authorization': `${token}`
        }});
}